var app = angular.module('leonardo');

var CategoryRestService = function(BaseRestService) {
  return new BaseRestService('categories');
};

app.factory('CategoryRestService', ['BaseRestService', CategoryRestService]);

